import { Button } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

const EmptyChatStatus = () => {
  return (
    <div className="chatbox EmptyChatStatus">
    <div className="modal-dialog-scrollable">
        <div className="modal-content">  
        <div className="modal-body bg-EB">
        <div className="select-message-box" style={{display: 'flex',justifyContent: 'center', flexDirection: 'column',alignItems: 'center', height: '100%',}}> 
          {/* <Link to="/members" style={{background: '#916008',textDecoration: 'none', color: '#fff', fontWeight: '600', fontSize: '15px', fontFamily: 'Neue Montreal', textTransform: 'capitalize', padding: '10px 80px'}} data-bs-toggle="modal" data-bs-target="#new-chat">
           Find Members
          </Link> */}
          <img src="/assets/images/start-chat2.png" className="img-fluid" alt="" />     <p className="font-14 fw-medium font-m color7b mt-16">Start the conversation by sending a message!</p>   </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default EmptyChatStatus;
